// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__16f0p","alertIcon":"ConfirmModal_alertIcon__17J2l"};